var _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2167 87.5589C70.5597 87.5589 72.459 89.4583 72.459 91.8013V93.8659C72.459 103.37 64.7561 111.073 55.252 111.073C45.749 111.073 38.0449 103.371 38.0449 93.8716V91.807C38.0449 89.464 39.9443 87.5646 42.2873 87.5646C44.6303 87.5646 46.5296 89.464 46.5296 91.807V93.8716C46.5296 98.6828 50.4326 102.588 55.252 102.588C60.0701 102.588 63.9743 98.6841 63.9743 93.8659V91.8013C63.9743 89.4583 65.8737 87.5589 68.2167 87.5589Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6412 15.382C40.6412 7.31611 47.1774 0.77124 55.252 0.77124C63.3265 0.77124 69.8627 7.31611 69.8627 15.382V20.5746C69.8627 22.9176 67.9633 24.817 65.6203 24.817C63.2773 24.817 61.378 22.9176 61.378 20.5746V15.382C61.378 11.9991 58.6375 9.25599 55.252 9.25599C51.8664 9.25599 49.126 11.9991 49.126 15.382V20.5746C49.126 22.9176 47.2266 24.817 44.8836 24.817C42.5406 24.817 40.6412 22.9176 40.6412 20.5746V15.382Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1272 24.2853C38.317 24.2853 28.7399 33.8579 28.7399 45.6725V61.4938C28.7399 65.6181 27.0986 69.576 24.1827 72.4919L20.5569 76.1177C19.2304 77.4442 18.4847 79.2447 18.4847 81.1162C18.4847 84.6786 21.3707 87.5646 24.9331 87.5646H85.5765C89.1388 87.5646 92.0249 84.6786 92.0249 81.1162C92.0249 79.2447 91.2792 77.4442 89.9527 76.1177L86.3269 72.4919C83.411 69.576 81.7696 65.6181 81.7696 61.4938V45.6725C81.7696 33.8624 72.197 24.2853 60.3824 24.2853H50.1272ZM20.2552 45.6725C20.2552 29.1707 33.6322 15.8006 50.1272 15.8006H60.3824C76.8842 15.8006 90.2544 29.1776 90.2544 45.6725V61.4938C90.2544 63.3653 91 65.1658 92.3265 66.4923L95.9524 70.1181C98.8682 73.034 100.51 76.9918 100.51 81.1162C100.51 89.3646 93.8249 96.0493 85.5765 96.0493H24.9331C16.6847 96.0493 9.99995 89.3646 9.99995 81.1162C9.99995 76.9918 11.6413 73.034 14.5572 70.1181L18.183 66.4923C19.5095 65.1658 20.2552 63.3653 20.2552 61.4938V45.6725Z",
    fill: "#E5E5E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.00003,
    y: 113,
    width: 10,
    height: 150,
    rx: 5,
    transform: "rotate(-135 5.00003 113)",
    fill: "#E5E5E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotifications);
export default __webpack_public_path__ + "static/media/no-notifications.1454a14c.svg";
export { ForwardRef as ReactComponent };